export class MessageSitecoreTemplate{
    MessagesHeader: string;
    EmptyMessages: string;
}